import { useViews } from './useViews';
export const useIsViewCached = viewId => {
  const views = useViews();
  return Boolean(viewId && views[viewId]);
};